module.exports = __tmimport("widgets/flash");